<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="cancel" @click="$emit('return_modal_cancel_form')" v-if="modal == true" />
        <action-button type="back" @click="$router.go(-1)" v-if="modal != true" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(person.id)" v-if="$can('person-delete')" />
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.first_name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('persons.first_name')"
                  :error-messages="errors.collect('person.first_name')"
                  data-vv-name="person.first_name"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="person.last_name"
                  class="required-field"
                  v-validate="'required|max:50'"
                  :label="$t('persons.last_name')"
                  :error-messages="errors.collect('person.last_name')"
                  data-vv-name="person.last_name"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg6 md6 sm6 xs12>
                <vue-tel-input-vuetify
                  v-validate="'required'"
                  :label="$t('persons.mobile')"
                  v-model="person.mobile"
                  @input="
                    (formattedNumber, { number, valid, country }) => {
                      person.mobile = number.significant || formattedNumber
                      person.mobile_code = country.dialCode || null
                    }
                  "
                  placeholder=""
                  name="person.mobile"
                  :error-messages="errors.collect('person.mobile')"
                  defaultCountry="NO"
                ></vue-tel-input-vuetify>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="user.email"
                  :label="$t('persons.email')"
                  class="required-field"
                  v-validate="'required|email|max:255'"
                  :error-messages="errors.collect('person.email')"
                  data-vv-name="person.email"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="person.organisation_id"
                  v-model="person.organisation_id"
                  :items="organisations"
                  item-text="name"
                  item-value="id"
                  :label="$t('organisations.title')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('person.organisation_id')"
                  @change="checkOrganisationIfSystemOwner(person.organisation_id)"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <!--<v-flex lg3 md4 sm6 xs12 v-if="show_create_user">
                                <v-checkbox
                                    name="person.created_as_user"
                                    v-model="person.created_as_user"
                                    :label="$t('persons.create_as_user')"
                                ></v-checkbox>
                            </v-flex>-->
              <v-flex xs12>
                <v-textarea
                  name="person.comments"
                  v-model="person.comments"
                  :label="$t('persons.comments')"
                  :error-messages="errors.collect('person.comments')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import PhoneNumber from "awesome-phonenumber"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"

export default {
  name: "PersonForm",

  props: ["id", "modal"],

  components: {
    VueTelInputVuetify
  },

  data() {
    return {
      page_title: "",
      predata: {},
      user: {},
      person: {},
      organisations: [],
      show_create_user: false,
      dictionary: {
        attributes: {
          "person.first_name": this.$t("persons.first_name"),
          //"person.middle_name": this.$t("persons.middle_name"),
          "person.last_name": this.$t("persons.last_name"),
          "person.email": this.$t("persons.email"),
          "person.mobile": this.$t("persons.mobile"),
          "person.comments": this.$t("persons.comments")
        }
      },
      organisations: []
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.person, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    let vm = this

    axios.get(this.API_URL + "organisations?show_all=true&resourcetype=organisation-basic").then((res) => {
      this.organisations = res.data.data

      if (!this.id) {
        this.page_title = this.$t("persons.new_person")
        this.person = {}

        // JSON stringify and parse to remove variable reactiveness
        this.loadPredata()
      } else {
        axios
          .get(this.API_URL + "person/" + this.id)
          .then((res) => {
            this.person = res.data.data
            this.user = res.data.data.user
            this.checkOrganisationIfSystemOwner(this.person.organisation_id)

            // JSON stringify and parse to remove variable reactiveness
            this.loadPredata()

            this.page_title = this.$t("persons.edit_person", {
              name: this.person.first_name + " " + this.person.last_name
            })
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    loadPredata() {
      this.predata = JSON.parse(JSON.stringify(this.person))
      this.predata.mobile_code = "47" // Norway country code

      if(this.predata.mobile) {
        let code = PhoneNumber(this.predata.mobile).getCountryCode()
        if (code) {
          let mobileJSON = PhoneNumber(this.predata.mobile).toJSON()
          this.predata.mobile = mobileJSON.number.significant || this.predata.mobile
          this.predata.mobile_code = code.toString()
        }
      }
    },
    checkOrganisationIfSystemOwner(id) {
      let org = this.organisations.find((i) => i.id == id && i.owner == 1)
      this.show_create_user = org ? true : false

      if (!this.show_create_user) {
        this.person.created_as_user = false
      }
    },

    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.id) {
              // Create
              axios
                .post(this.API_URL + "person", {
                  organisation_id: vm.person.organisation_id,
                  first_name: vm.person.first_name,
                  last_name: vm.person.last_name,
                  middle_name: vm.person.middle_name,
                  email: vm.user.email,
                  mobile: vm.$formatPhoneNumber(vm.person.mobile, vm.person.mobile_code),
                  comments: vm.person.comments,
                  created_as_user: null
                })
                .then((res) => {
                  vm.person = res.data.data
                  vm.loadPredata()

                  vm.user = res.data.data.user
                  vm.checkOrganisationIfSystemOwner(vm.person.organisation_id)

                  vm.page_title = vm.$t("persons.edit_person", {
                    name: this.person.first_name + " " + vm.person.last_name
                  })

                  vm.$awn.success(vm.$t("global.create_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "person",
                      mode: "add",
                      data: res.data.data
                    })
                  } else {
                    vm.$router.replace(this.BACKEND_URL + `/persons/edit/${vm.person.id}`).catch(() => {})
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "person", {
                  id: vm.person.id,
                  organisation_id: vm.person.organisation_id,
                  first_name: vm.person.first_name,
                  last_name: vm.person.last_name,
                  middle_name: vm.person.middle_name,
                  email: vm.user.email,
                  mobile: vm.$formatPhoneNumber(vm.person.mobile, vm.person.mobile_code),
                  comments: vm.person.comments,
                  created_as_user: null
                })
                .then((res) => {
                  vm.person = res.data.data
                  vm.loadPredata()

                  vm.user = res.data.data.user
                  vm.checkOrganisationIfSystemOwner(vm.person.organisation_id)

                  vm.page_title = vm.$t("persons.edit_person", {
                    name: this.person.first_name + " " + vm.person.last_name
                  })

                  vm.$awn.success(vm.$t("global.update_success"))

                  if (vm.modal) {
                    vm.$emit("return_modal_form", {
                      module: "person",
                      mode: "edit",
                      data: res.data.data
                    })
                  }
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "person/" + id)
            .then(() => {
              vm.$router.push(vm.BACKEND_URL + "/persons")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },

    phoneNoSpace() {
      if (this.person.mobile) {
        this.person.mobile = this.person.mobile.replace(/\s/g, "")
        let field = this.errors.items.find((i) => i.field == "person.mobile" && i.rule == "no_space")
        if (field) this.$validator.errors.removeById(field.id)
      }
    }
  }
}
</script>

<style scoped></style>
